// extracted by mini-css-extract-plugin
export default {"component":"AccessPage_component__n0t4D","vertical":"AccessPage_vertical__Rd7qu","box":"AccessPage_box__pjGXz","pre":"AccessPage_pre__3a00i"};